import React from 'react';
import { Stack, Inline } from '@/Components/ui/layout';
import { Heading } from '@/Components/ui/typography';
import { Input } from '@/Components/ui/input';
import { Label } from '@/Components/ui/label';
import { Textarea } from '@/Components/ui/textarea';

function PersonalInformation({personalInfo, setPersonalInfo}) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPersonalInfo((prev) => ({ ...prev, [name]: value || '' }));
  };

  const formValues = {
    firstName: personalInfo?.firstName || '',
    lastName: personalInfo?.lastName || '',
    email: personalInfo?.email || '',
    phone: personalInfo?.phone || '',
    city: personalInfo?.city || '',
    bio: personalInfo?.bio || ''
  };
  return (
    <section className="flex flex-col items-center -mt-2.5 w-full max-w-full p-5 bg-transparent">
      <div className="flex justify-between items-center w-full mb-5">
        <Heading level="h2" size="2xl" className="font-bold text-slate-300 ml-3">
          Personal Information
        </Heading>
      </div>

      <form className="flex flex-col w-full max-w-[1000px] gap-5 -ml-[90px]">
        <Inline spacing="xl" className="justify-between gap-[160px]">
          <Stack spacing="xs" className="flex-1 flex-col">
            <Label htmlFor="firstName">First Name</Label>
            <Input
              type="text"
              id="firstName"
              name='firstName'
              className="rounded-lg border border-slate-700 bg-transparent text-slate-400 py-2.5 px-2.5 -mt-0.5 transition-all h-[40%] focus:border-green-400 focus:outline-none"
              value={formValues.firstName}
              onChange={handleChange}
              placeholder="Enter your first name"
            />
          </Stack>
          <Stack spacing="xs" className="flex-1 flex-col">
            <Label htmlFor="lastName">Last Name</Label>
            <Input
              type="text"
              id="lastName"
              name='lastName'
              className="rounded-lg border border-slate-700 bg-transparent text-slate-400 py-2.5 px-2.5 -mt-0.5 transition-all h-[40%] focus:border-green-400 focus:outline-none"
              value={formValues.lastName}
              onChange={handleChange}
              placeholder="Enter your last name"
            />
          </Stack>
        </Inline>
        <Inline spacing="xl" className="justify-between gap-[160px]">
          <Stack spacing="xs" className="flex-1 flex-col">
            <Label htmlFor="email">Email Address</Label>
            <Input
              type="email"
              id="email"
              name="email"
              className="rounded-lg border border-slate-700 bg-transparent text-slate-400 py-2.5 px-2.5 -mt-0.5 transition-all h-[40%] focus:border-green-400 focus:outline-none"
              value={formValues.email}
              onChange={handleChange}
              placeholder="Enter your email"
            />
          </Stack>
          <Stack spacing="xs" className="flex-1 flex-col">
            <Label htmlFor="phone">Phone</Label>
            <Input
              type="tel"
              id="phone"
              name='phone'
              className="rounded-lg border border-slate-700 bg-transparent text-slate-400 py-2.5 px-2.5 -mt-0.5 transition-all h-[40%] focus:border-green-400 focus:outline-none"
              value={formValues.phone}
              onChange={handleChange}
              placeholder="Enter your phone number"
            />
          </Stack>
        </Inline>
        <Inline spacing="xl" className="justify-between gap-[160px]">
          <Stack spacing="xs" className="flex-1 flex-col">
            <Label htmlFor="city">City</Label>
            <Input
              type="text"
              id="city"
              name='city'
              className="rounded-lg border border-slate-700 bg-transparent text-slate-400 py-2.5 px-2.5 -mt-0.5 transition-all h-[40%] focus:border-green-400 focus:outline-none"
              value={formValues.city}
              onChange={handleChange}
              placeholder="Enter your city"
            />
          </Stack>
          <Stack spacing="xs" className="flex-1 flex-col">
            <Label htmlFor="bio">Bio</Label>
            <Textarea
              id="bio"
              name='bio'
              className="min-h-[80px] resize-none rounded-lg border border-slate-700 bg-transparent text-slate-400 py-2.5 px-2.5 -mt-0.5 transition-all focus:border-green-400 focus:outline-none"
              value={formValues.bio}
              onChange={handleChange}
              placeholder="Tell us about yourself"
            />
          </Stack>
        </Inline>
      </form>
    </section>
  );
}

export default PersonalInformation;
